import { Injectable } from '@angular/core';
import { IPaymentGatewayProvider } from "./payment-gateway-provider";
import { Observable, BehaviorSubject } from "rxjs";
import { PaymentModel, PaymentVoucher } from '../../models/payment-models/payment.model';
import { PaymentStatusModel } from '../../models/payment-models/payment-status.model';
import { ExternalPaymentModel, PaymentsModel } from '../../models/payment-models/external-payment.model';
import { NavigationService } from 'src/app/shared/utils/navigation';
import { environment } from 'src/environments/environment'
import { PaymentService } from '../payment-services';
import { PaymentConstant } from 'src/app/modules/order/shared';
import { PaysafeCheckOutRequestModel } from '../../models/payment-models/paysafe-checkout-request.model';
declare var paysafe: any;

@Injectable({
    providedIn: 'root'
})
export class EcommpayGatewayService implements IPaymentGatewayProvider {

    public readonly PAYMENT_CONSTANT = PaymentConstant;
    private _responseStatus: string;
    private _responseParam: URLSearchParams;
    
    constructor(private paymentService: PaymentService) {
    }

    public getResponseStatus(): string {
        return this._responseStatus;
    }

    public resetResponseStatus(): void {
        this._responseStatus = null;
    }

    public getResponseParam(key: string): string {
        if (!this._responseParam) {
            return null;
        }
        return this._responseParam.get(key);
    }

    public processPayment(payment: ExternalPaymentModel): Observable<PaymentStatusModel> {
        const observable$ = new BehaviorSubject<PaymentStatusModel>(null);
        const initialPayment = this.createInitialPayment(payment.recordLocator,
            payment.orderId,
            payment.amount.currencyCode,
            payment.amount.value,
            payment.organisationCode,
            payment.payments,
            payment.paymentVoucher);


        this.paymentService.processPayment(initialPayment)
        .subscribe((response: PaymentStatusModel) => {
             observable$.next(response);
        });
        return observable$;
    }

    private createInitialPayment(recordLocator: string,
        orderId: string,
        paymentCurrency: string,
        paymentAmount: number,
        organisationCode: string,
        payments: PaymentsModel,
        paymentVoucher: PaymentVoucher): PaymentModel {

        return {
            context: {
                language: "en",
                currencyCode: "EUR",
                organisationCode: organisationCode,
                organisationId: null
            },
            orderNumber: recordLocator,
            orderId: orderId,
            formOfPayments: null,
            total: {
                sales: {
                    currencyCode: paymentCurrency,
                    amount: paymentAmount
                }
            },
            payments: [payments],
            paymentVoucher: paymentVoucher,
            redirect: null
        };
    }
    public handlePaymentPageResponse(): void {
        return;
    }
}